﻿import './assets/styles/options.scss'
import jQuery from 'jquery'
import util from 'utils'

import template from './assets/templates/options.mst'

function action (event, widget, params) {
  // Render action template
  var element = jQuery(jQuery.mustache(template, {
    title: params.title,
    options: params.options,
    sender: 'assistant',
    time: params.time || widget.getLocalDate(),
    origin: params.origin
  }))

  var buttons = element.find('button')
  
  //if one button was clicked before, we disable the rest of buttons
  if (buttons.hasClass('reply-clicked')) {
    buttons.siblings().prop('disabled', true)
  }

  buttons.on('click', function () {
    buttons.removeClass('reply-clicked')
    var button = jQuery(this)
    // buttons.css('background-color', '#2e1fc8')
    // button.css('background-color', '#ff3d00')
    button.addClass('reply-clicked')

    buttons.siblings().prop('disabled', true) 

    widget._input.focus()

    //OnClick button marking event 
    var originButton = button.attr('data-analytics-option-origin')
    var textButton = button.attr('data-analytics-option')
    
    //Google Data Manager integration
    dataLayer.push({
      'event' : 'GARDevent',
      'eventCategory': 'claudia - widget interacciones',
      'eventAction': 'click to action',
      'eventLabel' : util.normalizeText(textButton),
      'variant' : util.normalizeText(originButton)
    });  

    widget.send({
      type: 'text',
      labelButton: button.text(),
      payload: button.val(),
      mark: 'option',
      id_option: params.id_option
    })
  })

  widget._log(element)
}

export default action
